/**
 * Funzione utilizzata per verificare se ci si trova nella build di produzione
 */
// eslint-disable-next-line import/prefer-default-export
const isProduction = () => process.env.NODE_ENV === 'production';

export { isProduction };
